<mat-card appearance="outlined" class="mt2">
  <mat-card-header>
    <mat-card-title translate="">Period</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form class="pt1 max-xl:flex max-xl:flex-col flex gap-[2rem]" [formGroup]="mortgageProgressesFilter">
      <div class="flex justify-start content-center items-center max-xl:flex max-xl:flex-col gap-[0.5rem]">
        <label translate="">Coming</label>
        <mat-form-field floatLabel="never">
          <mat-select formControlName="duration">
            <mat-option [value]="'3'"><span translate="" [translateParams]="{value: 3}">... year</span>
          </mat-option>
          <mat-option [value]="'5'"><span translate="" [translateParams]="{value: 5}">... year</span>
        </mat-option>
        <mat-option [value]="'7'"><span translate="" [translateParams]="{value: 7}">... year</span>
      </mat-option>
      <mat-option [value]="'10'"><span translate="" [translateParams]="{value: 10}">... year</span>
    </mat-option>
    <mat-option [value]="'20'"><span translate="" [translateParams]="{value: 20}">... year</span>
  </mat-option>
  <mat-option [value]="'30'"><span translate="" [translateParams]="{value: 30}">... year</span>
</mat-option>
</mat-select>
</mat-form-field>
</div>
<div class="flex justify-start content-center items-center max-xl:flex max-xl:flex-col gap-[0.5rem]">
  <label translate="">Scale:</label>
  <mat-radio-group color="primary" formControlName="scale">
    <mat-radio-button value="month"><span class="mr1" translate="">Months</span></mat-radio-button>
    <mat-radio-button value="year"><span class="mr1" translate="">Years</span></mat-radio-button>
  </mat-radio-group>
</div>
</form>
<div class="table-overview">
  <mat-table [dataSource]="mortgageProgressesData">
    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[225px]">
        @if (mortgageProgressesFilter.get('scale')?.value == 'month') {
          <span translate="">Month</span>
        }
        @if (mortgageProgressesFilter.get('scale')?.value == 'year') {
          <span translate="">Year</span>
        }
      </mat-header-cell>
      <mat-cell *matCellDef="let mortgageProgress" class="grow-0 shrink-0 basis-[225px]">
        @if (mortgageProgressesFilter.get('scale')?.value == 'month') {
          <span>{{mortgageProgress.date | date:'MMMM y'}}</span>
        }
        @if (mortgageProgressesFilter.get('scale')?.value == 'year') {
          <span>{{mortgageProgress.date | date:'y'}}</span>
        }
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="interest">
      <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[150px]">
        <span translate="">Interest</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let mortgageProgress" class="grow-0 shrink-0 basis-[150px]">
        {{mortgageProgress.interest | currency:'EUR':'symbol':'1.0-0'}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="repayment">
      <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[150px]">
        <span translate="">Repayment</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let mortgageProgress" class="grow-0 shrink-0 basis-[150px]">
        {{mortgageProgress.repayment | currency:'EUR':'symbol':'1.0-0'}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="remainingLoan">
      <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[150px]">
        <span translate="">Remaining</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let mortgageProgress" class="grow-0 shrink-0 basis-[150px]">
        {{mortgageProgress.remainingLoan | currency:'EUR':'symbol':'1.0-0'}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loanToValue">
      <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-full">
        <span translate="">LTV</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let mortgageProgress" class="grow-0 shrink-0 basis-full">
        {{mortgageProgress.loanToValue | number:'1.0-2'}}%
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="total">
      <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[150px]">
        <span translate="">Total</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let mortgageProgress" class="grow-0 shrink-0 basis-[150px]">
        {{mortgageProgress.total | currency:'EUR':'symbol':'1.0-0'}}
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="mortgageProgressesDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let mortgageProgress; columns: mortgageProgressesDisplayedColumns;">
    </mat-row>
  </mat-table>
  @if (isLoadingMortgageProgress === false && mortgageProgressesData && mortgageProgressesData.length === 0) {
    <p translate="">No dates found</p>
  }
  @if (isLoadingMortgageProgress !== false) {
    <div class="loader mt1">
      <mat-spinner diameter="32"></mat-spinner>
      <span translate="">Retrieving dates</span>
    </div>
  }
</div>
</mat-card-content>
</mat-card>